import { VueConstructor } from "vue";
import Modal from "./Modal.vue";

export default {
  install(Vue: VueConstructor) {
    Vue.component("modal", Modal);
  }
};
